(function cookiebanner() {
    const texts = {
        // eslint-disable-next-line max-len
        text: `This site uses Google Analytics for usage analysis and statistics. By clicking <i>Accept</i>, you agree to that usage. More info is available in our <a href="${window.BASE_URL}/static/privacy">Privacy Policy</a>.`,
        yay: 'Accept',
        nay: 'Refuse',
    };

    /**
     * simple language string accessor
     *
     * @param string
     * @return string
     */
    function getString(string) {
        return texts[string];
    }

    /**
     * Execute the tracking script
     */
    function addTracking() {
        if (!window.GACODE) {
            return;
        }

        /* eslint-disable */
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtag/js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer',window.GACODE);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function(){dataLayer.push(arguments);}
        window.gtag('js', new Date());
        window.gtag('config', window.GACODE, { 'anonymize_ip': true });
        /* eslint-enable */

        // track outbound links as google analytics events
        // special handling for ad clicks
        // we open all external links externally, this ensures our click handling is not
        // interrupted
        document.querySelectorAll('a').forEach((link) => {
            if (link.host === window.location.host) return; // only external
            link.setAttribute('target', '_blank'); // always open in new tab

            // handle clicks
            link.addEventListener('click', () => {
                // log ad click as extra event
                if (link.dataset.log) {
                    window.gtag('event', 'click', {
                        event_category: 'ads',
                        event_label: link.dataset.log,
                        transport_type: 'beacon',
                    });
                }

                // normal log
                window.gtag('event', 'click', {
                    event_category: 'outbound',
                    event_label: link.href,
                    transport_type: 'beacon',
                });
            }, false);
        });
    }

    /**
     * Handle nay clicks
     */
    function clickNay() {
        window.localStorage.setItem('cookiebanner', 'nay');
        document.querySelector('.mtx-cookiebanner').remove();
    }

    /**
     * Handle yes clicks
     */
    function clickYay() {
        window.localStorage.setItem('cookiebanner', 'yay');
        document.querySelector('.mtx-cookiebanner').remove();
        addTracking();
    }

    /**
     * Show the banner
     */
    function showBanner() {
        const div = document.createElement('div');
        div.className = 'mtx-cookiebanner';
        div.innerHTML = getString('text');

        const yay = document.createElement('button');
        yay.className = 'yay';
        yay.innerHTML = getString('yay');
        yay.addEventListener('click', clickYay);

        const nay = document.createElement('button');
        nay.className = 'nay';
        nay.innerHTML = getString('nay');
        nay.addEventListener('click', clickNay);

        div.appendChild(document.createElement('hr'));
        div.appendChild(yay);
        div.appendChild(nay);

        document.body.appendChild(div);
    }


    // main

    // check cookie state and decide what to do
    const state = window.localStorage.getItem('cookiebanner');
    if (state === null) {
        showBanner();
    } else if (state === 'yay') {
        addTracking();
    }
}());
